import { Formula } from "models/product.types";

export const FORMULA_COLORS = {
  PLUS: {
    base: "#0F6E56",
    light: "#E1F5EE",
    dark: "#085041",
  },
  FLEX: {
    base: "#185FA5",
    light: "#E6F1FB",
    dark: "#0C447C",
  },
  PERSONAL: {
    base: "#993556",
    light: "#FBEAF0",
    dark: "#72243E",
  },
} as const;

export const CART_FORMULA_STORAGE_KEY = "cartFormula";

export function getFlowClass(formula?: Formula | null): string {
  if (!formula) return "";
  const map: Record<Formula, string> = {
    PLUS: "flow--plus",
    FLEX: "flow--flex",
    PERSONAL: "flow--personal",
    START: "flow--flex",
  };
  return map[formula] ?? "";
}

export function setCartFormula(formula: Formula) {
  sessionStorage.setItem(CART_FORMULA_STORAGE_KEY, formula);
}

export function getCartFormula(): Formula | null {
  const stored = sessionStorage.getItem(CART_FORMULA_STORAGE_KEY);
  if (stored === "PLUS" || stored === "FLEX" || stored === "PERSONAL" || stored === "START") {
    return stored;
  }
  return null;
}

export function clearCartFormula() {
  sessionStorage.removeItem(CART_FORMULA_STORAGE_KEY);
}

export function isFormulaFlowPath(pathname: string): boolean {
  return (
    pathname.startsWith("/cart/") ||
    pathname === "/products/add-physical-product" ||
    (pathname.startsWith("/products/") && pathname !== "/products") ||
    pathname === "/bundles" ||
    pathname.startsWith("/bundles/")
  );
}

export function shouldApplyFormulaFlow(pathname: string, formula: Formula | null | undefined): boolean {
  return isFormulaFlowPath(pathname) && !!formula;
}

export function parseFamilyDisplay(name: string, isNew?: boolean): {
  displayName: string;
  isNew: boolean;
} {
  if (isNew) {
    const cleaned = name.replace(/^\(NEW\)\s*/i, "").trim();
    return { displayName: cleaned || name, isNew: true };
  }
  const match = name.match(/^\(NEW\)\s*/i);
  if (match) {
    return { displayName: name.slice(match[0].length).trim(), isNew: true };
  }
  return { displayName: name, isNew: false };
}

export function getFormulaSx(formula: Formula) {
  const colors = FORMULA_COLORS[formula as keyof typeof FORMULA_COLORS] ?? FORMULA_COLORS.FLEX;
  return {
    borderColor: colors.base,
    backgroundColor: colors.light,
    color: colors.dark,
  };
}
